const fileConfig = () => {
	
	 const config = "node";

	return config;
};

export default fileConfig;
